<template>
  <a-modal :visible="visible" :width="500" title="发送短信" :footer="null" @cancel="$emit('cancel')">
    <a-spin :spinning="spinning">
      <a-form :form="form" v-bind="formItemLayout" @submit="handlePost">
        <a-form-item label="手机号码">
          <a-input v-decorator="[
            'phone_number',
            { rules: [{ required: true, message: '请输入手机号码' }] },
          ]" style="width: 100%" />
        </a-form-item>
        <a-form-item :wrapperCol="{ span: 14, offset: 6 }">
          <a-button class="mr-6" type="primary" size="default" html-type="submit"> 提交</a-button>
          <a-button size="default" @click="$emit('cancel')">取消</a-button></a-form-item>
      </a-form>
    </a-spin>
  </a-modal>
</template>
<script>
import { sms_notice_send } from '@/api/contract'
import { message } from 'ant-design-vue';
export default {
  props: {
    visible: Boolean,
    info: {
      type: Object,
      default: () => { },
    },
  },
  data() {
    return {
      formItemLayout: {
        labelCol: { span: 6 },
        wrapperCol: { span: 14 },
      },
      form: this.$form.createForm(this, { name: 'smssent' }),
      ct: {
        ids: undefined,
        phone_number: undefined
      },
      spinning: false,
      loading: false,
    };
  },
  mounted() {
  },
  watch: {
  },
  methods: {
    async handlePost(e) {
      this.form.validateFieldsAndScroll(async (err, values) => {
        let mobile = this.form.getFieldValue('phone_number');
        if (!/^1\d{10}$/.test(mobile)) {
          this.$message.error('请输入正确的手机号码');
          return;
        }
        try {
          this.spinning = true;
          this.ct.ids = String(this.info.id);
          let data = Object.assign(this.ct, values);
          await sms_notice_send(data);
          this.$emit('ok', data);
        } catch (error) {
          this.$error({ title: '错误提示', content: error });
        } finally {
          message.success(`短信已发送至: ${this.ct.phone_number}`)
          this.$emit('cancel');
          this.spinning = false;
        }
      },
      )
    },
  },
};
</script>
<style scoped lang="less"></style>
